import React, { useState } from 'react';
import WorkingFileUpload from '../components/WorkingFileUpload';

const SimpleUploadTest = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState('');

  const handleFileSelect = (file) => {
    console.log('✅ File selected in SimpleUploadTest:', file);
    setSelectedFile(file);
    setUploadStatus('File selected successfully!');
  };

  const handleFileRemove = () => {
    console.log('🗑️ File removed in SimpleUploadTest');
    setSelectedFile(null);
    setUploadStatus('');
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setUploadStatus('Please select a file first');
      return;
    }

    setUploadStatus('Uploading...');
    
    try {
      // Simulate upload
      await new Promise(resolve => setTimeout(resolve, 2000));
      setUploadStatus('Upload successful!');
    } catch (error) {
      setUploadStatus('Upload failed: ' + error.message);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-center">Simple File Upload Test</h1>
        
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold mb-6">Test File Upload</h2>
          
          <WorkingFileUpload
            onFileSelect={handleFileSelect}
            onFileRemove={handleFileRemove}
            maxSize={10}
          />

          {uploadStatus && (
            <div className={`mt-4 p-3 rounded ${
              uploadStatus.includes('success') ? 'bg-green-100 text-green-800' :
              uploadStatus.includes('failed') ? 'bg-red-100 text-red-800' :
              'bg-blue-100 text-blue-800'
            }`}>
              {uploadStatus}
            </div>
          )}

          {selectedFile && (
            <div className="mt-6">
              <button
                onClick={handleUpload}
                className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
              >
                Upload File
              </button>
            </div>
          )}

          <div className="mt-8 p-4 bg-gray-50 rounded">
            <h3 className="font-semibold mb-2">Instructions:</h3>
            <ol className="list-decimal list-inside space-y-1 text-sm text-gray-700">
              <li>Click on the file input above</li>
              <li>Select an image file from your computer</li>
              <li>Check if the file appears in the preview</li>
              <li>Click "Upload File" to test the upload process</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleUploadTest;
